module.exports = __webpack_public_path__ + "img/5407025cd0dccf7d7a8527b5df4cae3e.png";